import { useMemo } from 'react';
import { useJiraSoftwareReports } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/jsw-reports-resource/index.tsx';
import type { UseReportsReturn } from './types.tsx';
import { extractData } from './utils/extract-data.tsx';

export const useReports = (): UseReportsReturn => {
	const { data, loading, error } = useJiraSoftwareReports();
	const extractedData = useMemo(() => data && extractData(data), [data]);
	// @ts-expect-error - TS2322 - Type '{ data: Reports | null; loading: boolean; error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; }' is not assignable to type 'UseReportsReturn'.
	return { data: extractedData, loading, error };
};
